import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: "/login", component: () => import("@/views/login/index"), hidden: true },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  // 手机端英文上传页 —— 不挂 Layout，因此无侧边栏、不进任何人的菜单
  { path: "/m/login", component: () => import("@/views/mobile/MobileLogin"), hidden: true },
  { path: "/m/upload", component: () => import("@/views/mobile/MobileUpload"), hidden: true },
  { path: "/m/recut", component: () => import("@/views/mobile/MobileRecut"), hidden: true },
  { path: "/m/continuous", component: () => import("@/views/mobile/MobileContinuous"), hidden: true },
  { path: "/m/ocr", component: () => import("@/views/mobile/MobileOcr"), hidden: true },
  { path: "/m/base", component: () => import("@/views/mobile/MobileBaseList"), hidden: true },
  { path: "/m/discounts", component: () => import("@/views/mobile/MobileDiscountList"), hidden: true },
  { path: "/m/imgs", component: () => import("@/views/mobile/MobileImgManager"), hidden: true },
  { path: "/m/recutPhoto", component: () => import("@/views/mobile/MobileRecutPhoto"), hidden: true },
  { path: "/m/recutBatch", component: () => import("@/views/mobile/MobileRecutBatch"), hidden: true },
  { path: "/m/scripts", component: () => import("@/views/mobile/MobileScripts"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" },
      },
    ],
  },
];

export const asyncRouterMap = [
  {
    path: "/marketing",
    component: Layout,
    redirect: "/marketing/traffic-sources",
    name: "marketing",
    alwaysShow: true,
    meta: { title: "Marketing", icon: "sms" },
    children: [
      {
        path: "traffic-sources",
        name: "trafficSources",
        component: () => import("@/views/marketing/trafficSources/index"),
        meta: { title: "Traffic Sources", icon: "table" },
      },
    ],
  },
  {
    path: "/growth",
    component: Layout,
    redirect: "/growth/acquisition",
    name: "growthAnalysis",
    alwaysShow: true,
    meta: { title: "增长分析", icon: "table" },
    children: [
      {
        path: "acquisition",
        name: "growthAcquisition",
        component: () => import("@/views/growth/acquisition/index"),
        meta: { title: "获客分析", icon: "table" },
      },
      {
        path: "activation",
        name: "growthActivation",
        component: () => import("@/views/growth/activation/index"),
        meta: {
          title: "激活漏斗",
          icon: "table",
          phase: "D2 · Phase 2（补 sign_up 埋点后交付）",
          description: "围绕真实需求意图、登录墙摩擦与注册后首次动作，定位用户在哪一步流失。",
          items: [
            "GA4 · yp_anon_id 口径激活漏斗：进站 → 选门店 → 看商品 → 想加清单 → 成功加清单。",
            "登录墙摩擦：wishlist_add_attempt → add_to_wishlist 转化率，实测基线 45%，匿名流失单列。",
            "DB 口径：注册后 7 日首次加清单 / 首次订阅 / 首次 Watch 率。",
          ],
        },
      },
      {
        path: "retention",
        name: "growthRetention",
        component: () => import("@/views/growth/retention/index"),
        meta: {
          title: "留存分析",
          icon: "table",
          phase: "D3 · Phase 3（后端接 BigQuery 后原生化）",
          description: "原生化之前，请从 D0 底部「留存 / 流量快照看板」入口查看，每周一自动更新。",
          items: [
            "cookie 口径 3 年月度 cohort 热力图。",
            "设备级 yp_anon_id 周留存曲线与热力表，减少 ITP 与身份污染影响。",
            "Sale Alert 发送量与命中率（DB 口径）。",
          ],
        },
      },
      {
        path: "revenue",
        name: "growthRevenue",
        component: () => import("@/views/growth/stub/index"),
        meta: {
          title: "收入分析",
          icon: "table",
          phase: "D4 · Phase 1.5（付费墙开闸前 1-2 周建设）",
          description: "付费墙开闸前完成监控仪表；广告收入继续以 D0 的 Ezoic 外部入口为准。",
          items: [
            "日成交笔数与金额（dk_premium_consent，amount_total 单位分）。",
            "活跃订阅数 / MRR / 月年结构（dk_stripe_*）。",
            "质检、取消与退款分布。",
            "流失（churn）与付费用户占比。",
          ],
        },
      },
      {
        path: "referral",
        name: "growthReferral",
        component: () => import("@/views/growth/referral/index"),
        meta: {
          title: "推荐分享",
          icon: "table",
          phase: "D5 · Phase 1（商品转发已点亮）",
          description: "商品转发渠道分布已接入真实数据；邀请注册、K 因子与清单分享仍待开闸。",
          items: [
            "商品转发渠道分布：copylink / sms / whatsapp / facebook / instagram / messenger / reddit / pinterest / email / X。",
            "邀请注册漏斗与 K 因子（dk_referral）仍待开闸。",
            "清单分享漏斗（created → viewed → imported → 接收者注册）仍待开闸。",
          ],
        },
      },
    ],
  },
  {
    path: "/dct",
    component: Layout,
    redirect: "/dct/priceImgMng",
    name: "dct",
    meta: { title: "折扣管理", icon: "product" },
    children: [
      {
        path: "priceImgMng",
        name: "priceImgMng",
        component: () => import("@/views/dct/priceImgMng/index"),
        meta: { title: "多图上传", icon: "product-list" },
      },
      {
        path: "historyPrice",
        name: "historyPrice",
        component: () => import("@/views/dct/discount/historyPrice"),
        meta: { title: "历史价格", icon: "product-list" },
      },
      {
        path: "imgManager",
        name: "imgManager",
        component: () => import("@/views/dct/imgManager/index"),
        meta: { title: "图库", icon: "product-list" },
      },
      {
        path: "recutImg",
        name: "recutImg",
        component: () => import("@/views/dct/imgManager/recutImg"),
        meta: { title: "补图", icon: "product-list" },
      },
      {
        path: "tempImg",
        name: "tempImg",
        hidden: true,
        component: () => import("@/views/dct/tempImg/index"),
        meta: { title: "临时图库", icon: "product-list" },
      },
      {
        path: "ocrInput",
        name: "ocrInput",
        component: () => import("@/views/dct/ocrInput/index"),
        meta: { title: "识别录入", icon: "product-list" },
      },
      {
        path: "tagReview",
        name: "tagReview",
        component: () => import("@/views/dct/tagReview/index"),
        meta: { title: "价签待审", icon: "product-list" },
      },
      {
        path: "recutPhoto",
        name: "recutPhoto",
        component: () => import("@/views/dct/recutPhoto/index"),
        meta: { title: "补拍管理", icon: "product-list" },
      },
      {
        path: "ocrTest",
        name: "ocrTest",
        hidden: true,
        component: () => import("@/views/dct/ocrTest/index"),
        meta: { title: "ocrTest", icon: "product-list" },
      },
      {
        path: "goodsBase",
        name: "goodsBase",
        component: () => import("@/views/dct/goodsBase/index"),
        meta: { title: "基础信息", icon: "product-list" },
      },
      {
        path: "discount",
        name: "discount",
        component: () => import("@/views/dct/discount/index"),
        meta: { title: "折扣管理", icon: "product-list" },
      },
      {
        path: "continuousImg",
        name: "continuousImg",
        component: () => import("@/views/dct/continuousImg/index"),
        meta: { title: "连续图片编号", icon: "product-list" },
      },
      {
        path: "hashTag",
        name: "hashTag",
        component: () => import("@/views/dct/hashTag/index"),
        meta: { title: "关键词设置", icon: "hash-tag" },
      },
    ],
  },
  {
    path: "/dealsAlert",
    component: Layout,
    redirect: "/dealsAlert/watchingList",
    name: "dealsAlert",
    meta: { title: "Deals Alert", icon: "product" },
    children: [
      {
        path: "watchingList",
        name: "watchingList",
        component: () => import("@/views/dealsAlert/watchingList/index"),
        meta: { title: "Watching List", icon: "product-list" },
      },
    ],
  },
  {
    path: "/gas",
    component: Layout,
    redirect: "/gas/gaslist",
    name: "gas",
    meta: { title: "油价管理", icon: "post" },
    children: [
      {
        path: "gaslist",
        name: "gaslist",
        component: () => import("@/views/gas/list/index"),
        meta: { title: "油价信息", icon: "gas-list" },
      },
      {
        path: "gashistory",
        name: "gashistory",
        component: () => import("@/views/gas/history/index"),
        meta: { title: "油价历史", icon: "gas-history" },
      },
    ],
  },
  {
    path: "/interaction",
    component: Layout,
    redirect: "/interaction/interaction",
    name: "interaction",
    meta: { title: "互动管理", icon: "post" },
    children: [
      {
        path: "interaction",
        name: "interaction",
        component: () => import("@/views/interaction/interaction/index"),
        meta: { title: "互动统计", icon: "scriptTemplate-list" },
      },
      {
        path: "likeforward",
        name: "likeforward",
        component: () => import("@/views/interaction/likeforward/index"),
        meta: { title: "点赞转发管理", icon: "background-list" },
      },
      {
        path: "comment",
        name: "comment",
        component: () => import("@/views/interaction/comment/index"),
        meta: { title: "评论管理", icon: "background-list" },
      },
      {
        path: "bannedUser",
        name: "bannedUser",
        component: () => import("@/views/interaction/bannedUser/index"),
        meta: { title: "禁言列表", icon: "background-list" },
      },
      {
        path: "sensitive",
        name: "sensitive",
        component: () => import("@/views/interaction/sensitive/index"),
        meta: { title: "敏感词设置", icon: "background-list" },
      },
    ],
  },
  {
    path: "/infoConfig",
    component: Layout,
    redirect: "/infoConfig/infoConfig",
    name: "infoConfigGroup",
    meta: { title: "信息管理", icon: "product" },
    children: [
      {
        path: "infoConfig",
        name: "infoConfig",
        component: () => import("@/views/dct/infoConfig/index"),
        meta: { title: "信息设置", icon: "product-list" },
      },
      {
        path: "rotationConfig",
        name: "rotationConfig",
        component: () => import("@/views/dct/rotationConfig/index"),
        meta: { title: "轮播图设置", icon: "product-list" },
      },
      {
        path: "broadcast",
        name: "broadcast",
        component: () => import("@/views/dct/broadcast/index"),
        meta: { title: "广播设置", icon: "product-list" },
      },
      {
        path: "flyers",
        name: "flyers",
        component: () => import("@/views/dct/flyers/index"),
        meta: { title: "flyer管理", icon: "product-list" },
      },
      {
        path: "copywriting",
        name: "copywriting",
        component: () => import("@/views/dct/copywriting/index"),
        meta: { title: "话术管理", icon: "product-list" },
      },
      {
        path: "abtest",
        name: "abtest",
        component: () => import("@/views/dct/infoConfig/abtest"),
        meta: { title: "AB测试", icon: "product-list" },
      },
    ],
  },
  {
    path: "/post",
    component: Layout,
    redirect: "/post/scriptTemplate",
    name: "post",
    meta: { title: "发帖/邮件", icon: "post" },
    children: [
      {
        path: "scriptTemplate",
        name: "scriptTemplate",
        component: () => import("@/views/post/scriptTemplate/index"),
        meta: { title: "模板管理", icon: "scriptTemplate-list" },
      },
      {
        path: "background",
        name: "background",
        component: () => import("@/views/post/background/index"),
        meta: { title: "封面/封底图模板", icon: "background-list" },
      },
      {
        path: "task",
        name: "task",
        component: () => import("@/views/post/task/index"),
        meta: { title: "发贴任务", icon: "task-list" },
      },
      {
        path: "template",
        name: "template",
        component: () => import("@/views/mail/template/index"),
        meta: { title: "邮件模版", icon: "template" },
      },
      {
        path: "mailtask",
        name: "mailtask",
        component: () => import("@/views/mail/task/index"),
        meta: { title: "邮件任务", icon: "mailtask" },
      },
      {
        path: "quickSend",
        name: "quickSend",
        component: () => import("@/views/mail/quickSend/index"),
        meta: { title: "一键店邮", icon: "mailtask" },
      },
    ],
  },
  {
    // 与 /growth 同属受限组，可见性名单在 utils/growthAccess.js 的 RESTRICTED_GROUPS，
    // 实际权限仍以服务端返回的菜单为准，这里不做任何角色判断。
    // 三条 name 必须与 V162 注册的 ums_menu 记录一致，否则 GenerateRoutes 匹配不上、路由不会注册。
    path: "/seo",
    component: Layout,
    redirect: "/seo/events",
    name: "seoAnalysis",
    alwaysShow: true,
    meta: { title: "SEO 追踪", icon: "table" },
    children: [
      {
        path: "events",
        name: "seoEvents",
        component: () => import("@/views/seo/events/index"),
        meta: { title: "SEO 事件台账", icon: "table" },
      },
      {
        path: "attribution",
        name: "seoAttribution",
        component: () => import("@/views/seo/attribution/index"),
        meta: { title: "SEO 归因对比", icon: "table" },
      },
    ],
  },
  {
    // 三条 name 必须与 V171 注册的 ums_menu 记录一致，否则 GenerateRoutes 匹配不上、路由不会注册。
    path: "/payroll",
    component: Layout,
    redirect: "/payroll/periods",
    name: "payroll",
    alwaysShow: true,
    meta: { title: "工资台账", icon: "table" },
    children: [
      {
        path: "periods",
        name: "payrollPeriods",
        component: () => import("@/views/payroll/periods/index"),
        meta: { title: "结算期", icon: "table" },
      },
      {
        // hidden 路由不需要对应的 ums_menu 记录——permission.js 的 hasPermission()
        // 只对未标 hidden 的路由要求 name 能在后端 menus 里匹配上。期明细从列表页
        // 点进来，不出现在侧边栏。用 this.$router.push({ name: 'payrollPeriodDetail',
        // query: { id } }) 跳转，期 id 走 query 参数，不是路径变量。
        path: "detail",
        name: "payrollPeriodDetail",
        hidden: true,
        component: () => import("@/views/payroll/periods/detail"),
        meta: { title: "期明细" },
      },
      {
        path: "annual",
        name: "payrollAnnual",
        component: () => import("@/views/payroll/annual/index"),
        meta: { title: "年度汇总", icon: "table" },
      },
    ],
  },
  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: { title: "商品", icon: "product" },
    children: [
      {
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: { title: "商品列表", icon: "product-list" },
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: { title: "添加商品", icon: "product-add" },
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: { title: "修改商品", icon: "product-add" },
        hidden: true,
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/productCate/index"),
        meta: { title: "商品分类", icon: "product-cate" },
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: { title: "添加商品分类" },
        hidden: true,
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: { title: "修改商品分类" },
        hidden: true,
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/pms/productAttr/index"),
        meta: { title: "商品类型", icon: "product-attr" },
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: { title: "商品属性列表" },
        hidden: true,
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: { title: "添加商品属性" },
        hidden: true,
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: { title: "修改商品属性" },
        hidden: true,
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/pms/brand/index"),
        meta: { title: "品牌管理", icon: "product-brand" },
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/pms/brand/add"),
        meta: { title: "添加品牌" },
        hidden: true,
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/pms/brand/update"),
        meta: { title: "编辑品牌" },
        hidden: true,
      },
    ],
  },
  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: { title: "订单", icon: "order" },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: { title: "订单列表", icon: "product-list" },
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: { title: "订单详情" },
        hidden: true,
      },
      {
        path: "deliverOrderList",
        name: "deliverOrderList",
        component: () => import("@/views/oms/order/deliverOrderList"),
        meta: { title: "发货列表" },
        hidden: true,
      },
      {
        path: "orderSetting",
        name: "orderSetting",
        component: () => import("@/views/oms/order/setting"),
        meta: { title: "订单设置", icon: "order-setting" },
      },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/oms/apply/index"),
        meta: { title: "退货申请处理", icon: "order-return" },
      },
      {
        path: "returnReason",
        name: "returnReason",
        component: () => import("@/views/oms/apply/reason"),
        meta: { title: "退货原因设置", icon: "order-return-reason" },
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/oms/apply/applyDetail"),
        meta: { title: "退货原因详情" },
        hidden: true,
      },
    ],
  },
  {
    path: "/sms",
    component: Layout,
    redirect: "/sms/coupon",
    name: "sms",
    meta: { title: "营销", icon: "sms" },
    children: [
      {
        path: "flash",
        name: "flash",
        component: () => import("@/views/sms/flash/index"),
        meta: { title: "秒杀活动列表", icon: "sms-flash" },
      },
      {
        path: "flashSession",
        name: "flashSession",
        component: () => import("@/views/sms/flash/sessionList"),
        meta: { title: "秒杀时间段列表" },
        hidden: true,
      },
      {
        path: "selectSession",
        name: "selectSession",
        component: () => import("@/views/sms/flash/selectSessionList"),
        meta: { title: "秒杀时间段选择" },
        hidden: true,
      },
      {
        path: "flashProductRelation",
        name: "flashProductRelation",
        component: () => import("@/views/sms/flash/productRelationList"),
        meta: { title: "秒杀商品列表" },
        hidden: true,
      },
      {
        path: "coupon",
        name: "coupon",
        component: () => import("@/views/sms/coupon/index"),
        meta: { title: "优惠券列表", icon: "sms-coupon" },
      },
      {
        path: "addCoupon",
        name: "addCoupon",
        component: () => import("@/views/sms/coupon/add"),
        meta: { title: "添加优惠券" },
        hidden: true,
      },
      {
        path: "updateCoupon",
        name: "updateCoupon",
        component: () => import("@/views/sms/coupon/update"),
        meta: { title: "修改优惠券" },
        hidden: true,
      },
      {
        path: "couponHistory",
        name: "couponHistory",
        component: () => import("@/views/sms/coupon/history"),
        meta: { title: "优惠券领取详情" },
        hidden: true,
      },
      {
        path: "brand",
        name: "homeBrand",
        component: () => import("@/views/sms/brand/index"),
        meta: { title: "品牌推荐", icon: "product-brand" },
      },
      {
        path: "new",
        name: "homeNew",
        component: () => import("@/views/sms/new/index"),
        meta: { title: "新品推荐", icon: "sms-new" },
      },
      {
        path: "hot",
        name: "homeHot",
        component: () => import("@/views/sms/hot/index"),
        meta: { title: "人气推荐", icon: "sms-hot" },
      },
      {
        path: "subject",
        name: "homeSubject",
        component: () => import("@/views/sms/subject/index"),
        meta: { title: "专题推荐", icon: "sms-subject" },
      },
      {
        path: "advertise",
        name: "homeAdvertise",
        component: () => import("@/views/sms/advertise/index"),
        meta: { title: "广告列表", icon: "sms-ad" },
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/sms/advertise/add"),
        meta: { title: "添加广告" },
        hidden: true,
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/sms/advertise/update"),
        meta: { title: "编辑广告" },
        hidden: true,
      },
    ],
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: { title: "权限", icon: "ums" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "用户列表", icon: "ums-admin" },
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "角色列表", icon: "ums-role" },
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: { title: "分配菜单" },
        hidden: true,
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: { title: "分配资源" },
        hidden: true,
      },
      {
        path: "goodsType",
        name: "goodsType",
        component: () => import("@/views/ums/goodsType/index"),
        meta: { title: "类别设置" },
        hidden: true,
      },
      {
        path: "store",
        name: "store",
        component: () => import("@/views/ums/store/index"),
        meta: { title: "门店管理" },
        hidden: true,
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: { title: "菜单列表", icon: "ums-menu" },
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add"),
        meta: { title: "添加菜单" },
        hidden: true,
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: { title: "修改菜单" },
        hidden: true,
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: { title: "资源列表", icon: "ums-resource" },
      },
      {
        path: "sysConfig",
        name: "sysConfig",
        component: () => import("@/views/ums/sysConfig/index"),
        meta: { title: "系统配置", icon: "ums-resource" },
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: { title: "资源分类" },
        hidden: true,
      },
    ],
  },
  {
    path: "/member",
    component: Layout,
    redirect: "/member/member",
    name: "member",
    meta: { title: "用户管理", icon: "ums" },
    children: [
      {
        path: "subscription",
        name: "subscription",
        component: () => import("@/views/member/subscription/index"),
        meta: { title: "订阅信息", icon: "ums-admin" },
      },
      {
        path: "member",
        name: "member",
        component: () => import("@/views/member/member/index"),
        meta: { title: "用户列表", icon: "ums-admin" },
      },
      {
        path: "shoppingList",
        name: "shoppingList",
        component: () => import("@/views/member/shoppingList/index"),
        meta: { title: "购物信息", icon: "ums-admin" },
      },
    ],
  },
  {
    path: "/blog",
    component: Layout,
    redirect: "/blog/list",
    name: "blog",
    meta: { title: "Blog管理", icon: "ums" },
    children: [
      {
        path: "list",
        name: "list",
        component: () => import("@/views/blog/blog/index"),
        meta: { title: "Blog列表", icon: "ums-admin" },
      },
      {
        path: "category",
        name: "blogCategory",
        component: () => import("@/views/blog/category/index"),
        meta: { title: "分类管理", icon: "ums-admin" },
      },
    ],
  },
  {
    path: "/goods",
    component: Layout,
    redirect: "/goods/list",
    name: "goods",
    meta: { title: "产品管理", icon: "ums" },
    children: [
      {
        path: "goods-list",
        name: "goods-list",
        component: () => import("@/views/goods/list/index"),
        meta: { title: "产品列表", icon: "ums-admin" },
      },
    ],
  },
  { path: "*", redirect: "/404", hidden: true },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});
